import { render } from "./ApportionOrder.vue?vue&type=template&id=37948b6c&scoped=true"
import script from "./ApportionOrder.vue?vue&type=script&lang=js"
export * from "./ApportionOrder.vue?vue&type=script&lang=js"

import "./ApportionOrder.vue?vue&type=style&index=0&id=37948b6c&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37948b6c"]])

export default __exports__